/**
 * Parse Supabase Storage public object URLs for delete/remove calls.
 * Format: …/storage/v1/object/public/{bucket}/{path}
 */
export function parseSupabasePublicObjectUrl(url) {
  if (!url || typeof url !== 'string') return null;
  try {
    const u = new URL(url.trim());
    const marker = '/storage/v1/object/public/';
    const idx = u.pathname.indexOf(marker);
    if (idx === -1) return null;
    const rest = u.pathname.slice(idx + marker.length);
    const slash = rest.indexOf('/');
    if (slash < 1) return null;
    const bucket = rest.slice(0, slash);
    const objectPath = decodeURIComponent(rest.slice(slash + 1));
    if (!bucket || !objectPath) return null;
    return { bucket, path: objectPath };
  } catch {
    return null;
  }
}

export async function removeSupabaseObjectByPublicUrl(supabase, publicUrl) {
  const parsed = parseSupabasePublicObjectUrl(publicUrl);
  if (!parsed || !supabase) return { ok: false, skipped: true };
  const { error } = await supabase.storage.from(parsed.bucket).remove([parsed.path]);
  if (error) return { ok: false, skipped: false, message: error.message };
  return { ok: true };
}
